import React from 'react'
const NotAuthorized = () => {
  return (
    <>
        {/* <p>
        NotAuthorized
        </p> */}

<div className="container">
            <div className="row">
                <div className="col-md-6 offset-md-3 text-center">
                    <h1 className="display-4" style={{ color: 'blue' }}>You are not authorized to access this screen</h1>
                    <img src={require("./../assets/images/not-authorized.gif")} />
                    {/* <p className="lead" style={{ color: 'red' }}>Sorry, the page you are looking for does not exist.</p> */}
                </div>
            </div>
        </div>

    </>
  )
}

export default NotAuthorized